import request from '@/utils/request'

export function queryContract(params) {
  return request({
    url: '/contract/queryContract',
    method: 'get',
    params
  })
}